// src/appRoutes.tsx
import { Routes, Route, Navigate } from 'react-router-dom';

import BrandsPage from '../pages/brands/BrandsPage';
import AzkListPage from '../pages/azk-list/AzkListPage';
import UserManagementPage from '../pages/user-management/UserManagementPage';
import UploadPage from '../pages/upload/UploadPage';
import AzkBindingPage from '../pages/azk-binding/AzkBindingPage';
import PriceProcessingPage from '../pages/price-processing/PriceProcessingPage';
import PricingRegionalPage from '../pages/pricing/regional/PricingRegionalPage';
import PricingProvincePage from '../pages/pricing/province/PricingProvincePage';
import PriceComparisonPage from '../pages/price-comparison/PriceComparisonPage';
import OrdersPage from '../pages/orders/OrdersPage';
import SchedulerPage from '../pages/scheduler/SchedulerPage';
import ProvinceStationsPage from '../pages/pricing/province/stations/ProvinceStationsPage';
import RegionalStationsPageNew from '../pages/pricing/regional/stations/RegionalStationsPage.tsx';

export const AppRoutes = ({ ProtectedRoute }: { ProtectedRoute?: any }) => {
  const Wrapper = ProtectedRoute || (({ children }: any) => <>{children}</>);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/pricing-regional" replace />} />

      <Route
        path="/brands"
        element={
          <Wrapper path="/brands">
            <BrandsPage />
          </Wrapper>
        }
      />
      <Route
        path="/azk-list"
        element={
          <Wrapper path="/azk-list">
            <AzkListPage />
          </Wrapper>
        }
      />
      <Route
        path="/user-management"
        element={
          <Wrapper path="/user-management">
            <UserManagementPage />
          </Wrapper>
        }
      />
      <Route
        path="/upload"
        element={
          <Wrapper path="/upload">
            <UploadPage />
          </Wrapper>
        }
      />
      <Route
        path="/azk-binding"
        element={
          <Wrapper path="/azk-binding">
            <AzkBindingPage />
          </Wrapper>
        }
      />
      <Route
        path="/price-processing"
        element={
          <Wrapper path="/price-processing">
            <PriceProcessingPage />
          </Wrapper>
        }
      />
      <Route
        path="/pricing-regional"
        element={
          <Wrapper path="/pricing-regional">
            <PricingRegionalPage />
          </Wrapper>
        }
      />
      <Route
        path="/pricing-regional/regional/:region"
        element={
          <Wrapper path="/pricing-regional">
            <RegionalStationsPageNew />
          </Wrapper>
        }
      />
      <Route
        path="/pricing-province"
        element={
          <Wrapper path="/pricing-province">
            <PricingProvincePage />
          </Wrapper>
        }
      />
      <Route
        path="/pricing-province/province/:province"
        element={
          <Wrapper path="/pricing-province">
            <ProvinceStationsPage />
          </Wrapper>
        }
      />
      <Route
        path="/price-comparison"
        element={
          <Wrapper path="/price-comparison">
            <PriceComparisonPage />
          </Wrapper>
        }
      />
      <Route
        path="/orders"
        element={
          <Wrapper path="/orders">
            <OrdersPage />
          </Wrapper>
        }
      />
      <Route
        path="/scheduler"
        element={
          <Wrapper path="/scheduler">
            <SchedulerPage />
          </Wrapper>
        }
      />
    </Routes>
  );
};
